import { useContext } from 'react';

import { useLazyBackgrounds } from '@/hooks/onboarding/useLazyBackgrounds';

import { Backgrounds } from '../../ConfigData/BackgroundSet';
import { PreSignupFlowContext } from '../../PreSignupProvider';
import { FixedBackground } from './styles';

const LazyBackgrounds = () => {
	const lazyBackgrounds = useLazyBackgrounds(Backgrounds);
	const { activeScreenKey: activeScreen, activeFlowKey } = useContext(PreSignupFlowContext);

	return (
		<>
			{lazyBackgrounds.map(bg => {
				return (
					<FixedBackground
						key={bg.src}
						src={bg.src}
						isVisible={activeScreen === bg.screen && activeFlowKey === bg.flow}
						isStretchedMobile={bg.isStretchedMobile}
						hasGrayFade={bg.hasGrayFade}
					/>
				);
			})}
		</>
	);
};

export default LazyBackgrounds;
